import { c as _c } from "react/compiler-runtime";
import { Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
export const NavGroup = t0 => {
  const $ = _c(5);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Text color="colorPalette.fg/40" paddingX={3} textStyle="labelXs">{label}</Text>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <VStack align="stretch" gap={1}>{t1}{children}</VStack>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};